/**
 * Asynchronously loads the component for NotFoundPage
 */

import { lazyLoad } from 'utils/loadable';

export const StockAdjustmentCreatePage = lazyLoad(
  () => import('./index'),
  module => module.StockAdjustmentCreatePage
);
